<template>
    <DFormRow
        :label="__('customers.contracts.installments')"
        :error="errors.installments"
        :hint="hint ?? ''"
    >
        <div
            role="group"
            class="form-group"
        >
            <DInput
                id="installments"
                :model-value="modelValue"
                type="number"
                min="0"
                @update:modelValue="emit('update:modelValue', $event)"
                @update:checked="installmentsChanged"
            />
        </div>
    </DFormRow>
</template>

<script setup>
defineProps({
    modelValue: {
        type: String,
        default: null
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    hint: {
        type: String,
        default: null
    }
})

const emit = defineEmits(['installmentsChanged', 'update:modelValue'])

function installmentsChanged (value) {
    emit('installmentsChanged', value)
}
</script>
